import React from 'react';
import {
    CloudArrowUpIcon,
    ChartBarIcon,
    SparklesIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline';

const STEPS = [
    {
        icon: <CloudArrowUpIcon className="w-7 h-7 text-blue-600" />,
        bg: 'bg-blue-100',
        number: '1',
        title: 'Déposez votre CV',
        desc: 'PDF ou Word. Le fichier reste confidentiel.',
    },
    {
        icon: <ChartBarIcon className="w-7 h-7 text-purple-600" />,
        bg: 'bg-purple-100',
        number: '2',
        title: 'Choisissez votre secteur',
        desc: 'L’analyse s’adapte au métier visé.',
    },
    {
        icon: <SparklesIcon className="w-7 h-7 text-green-600" />,
        bg: 'bg-green-100',
        number: '3',
        title: 'Recevez votre aperçu',
        desc: 'Score et 3 conseils offerts. Après paiement, réimportez le CV pour le rapport IA et le CV restructuré.',
    },
];

const OnboardingModal = ({ onClose }) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative animate-fadeIn"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    aria-label="Fermer"
                >
                    <XMarkIcon className="w-5 h-5" />
                </button>

                <div className="text-center mb-6">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl mb-4">
                        <SparklesIcon className="w-8 h-8 text-white" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-1">Bienvenue sur CV Analyse</h2>
                    <p className="text-gray-500 text-sm">Score et 3 conseils offerts, sans carte bancaire.</p>
                </div>

                <div className="space-y-4 mb-7">
                    {STEPS.map((step) => (
                        <div key={step.number} className="flex items-start gap-4">
                            <div className={`w-12 h-12 ${step.bg} rounded-xl flex items-center justify-center shrink-0`}>
                                {step.icon}
                            </div>
                            <div className="flex-1 pt-1">
                                <div className="flex items-center gap-2 mb-0.5">
                                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wide">Étape {step.number}</span>
                                </div>
                                <p className="font-semibold text-gray-800 text-sm">{step.title}</p>
                                <p className="text-xs text-gray-500 leading-relaxed">{step.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    onClick={onClose}
                    className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-4 rounded-2xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transform text-base"
                >
                    Commencer mon aperçu
                </button>
            </div>
        </div>
    );
};

export default OnboardingModal;
